import * as actions from './inventoryMaster/actions'
import * as mutations from './inventoryMaster/mutations'
import * as getters from './inventoryMaster/getters'

import { dataProps } from './inventoryMaster/properties'

const state = {
    list: null,
    nav: {
        page_number: 1, 
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, 
        search_term: '', 
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(dataProps)),
    autocomplete_list: [],
    loading: false,
    statement: {
        date_range: ['', ''],
        store_id: null,
        list: []
    },
    import_inventory_discount: [],
    stock_list: []
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryMaster.js